import { render, staticRenderFns } from "./RulesPopup.vue?vue&type=template&id=0ab0ab60&scoped=true&"
import script from "./RulesPopup.vue?vue&type=script&lang=js&"
export * from "./RulesPopup.vue?vue&type=script&lang=js&"
import style0 from "./RulesPopup.vue?vue&type=style&index=0&id=0ab0ab60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab0ab60",
  null
  
)

export default component.exports